import {HttpErrorResponse} from '@angular/common/http';

const CONFLICT_TYPE = 'export-configuration-name-conflict';

/**
 * NP20-958: Ist der Vorlagenname je (Berater, Name, Typ) belegt, legt das Backend nicht an,
 * sondern antwortet mit 409 und nennt die bestehende configId. Genau die braucht der Client,
 * um "vorhandene Vorlage aktualisieren" auf deren PUT zu fuehren.
 */
export function extractNameConflictConfigId(err: unknown): string | null {
  if (!(err instanceof HttpErrorResponse) || err.status !== 409) return null;
  const body = err.error as {type?: string; parameters?: {configId?: string}} | undefined;
  if (typeof body?.type !== 'string' || !body.type.includes(CONFLICT_TYPE)) return null;
  const configId = body.parameters?.configId;
  return typeof configId === 'string' && configId.length > 0 ? configId : null;
}
